import { Spinner } from "@/components/Spinner";

type ImagePreviewProps = {
	imageSrc: string | null;
	loading: boolean;
	onClose: () => void;
};

export const ImagePreview = ({ imageSrc, loading, onClose }: ImagePreviewProps) => (
	<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 cursor-pointer" onClick={onClose}>
		{loading || !imageSrc ? (
			<Spinner messages={[]} size={48} />
		) : (
			<img
				src={imageSrc}
				alt="Preview"
				className="max-w-[90vw] max-h-[90vh] object-contain rounded-lg"
				onClick={e => e.stopPropagation()}
			/>
		)}
	</div>
);
